import { createFileRoute } from "@tanstack/react-router";
import { StaffVisitsPage } from "@/components/app/visits/staff-visits-page";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/community/visits/")({
  beforeLoad: ({ context }) => guardRoute(context.me, "family-visits"),
  component: StaffVisitsPage,
});
